import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class SearchService {
    static getSearchResults = (searchValue, authorUserSub, resourceType, resourceSubtype, lastKey, groupId) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token: token,
            url: `${config.SearchService}${platformId}`,
            method: 'POST',
            body: {
                query: searchValue,
                author: authorUserSub,
                maxItemCount: 30,
                groupId,
                resourceType,
                resourceSubtype,
                // author
                lastKey
                // maxItemCount 1-50
            }
        });
    }
}
export default SearchService;